import React, {useState} from "react";
import classNames from "classnames";
import {Collapse} from "@mui/material";
import styles from "./ProductCharacteristics.module.scss";
import {Svg} from "@/shared/ui/Svg";

type Props = {
    insert_details: string | null;
    previewLength: number;
}

export const ProductInsertCharacteristics = ({insert_details, previewLength}: Props) => {
    const [insertsState, setInsertsState] = useState(false);

    let insertsDetailsText = insert_details ?? '';
    const insertsDetailsColumn = insertsDetailsText
        ? insertsDetailsText.split(';').map((el, i) => <div key={i}>{el}</div>)
        : [];

    return (
        <div className={styles.item}>
            <p className={styles.label}>Вставка</p>
            <div className={classNames(styles.value, styles.inserts)}>
                <Collapse in={insertsState} collapsedSize={20}>
                    {insertsDetailsColumn}
                </Collapse>
                {(insertsDetailsText.length > previewLength) && (
                    <div className={styles.icon} onClick={() => setInsertsState(!insertsState)}>
                        {insertsState
                            ? <Svg id={`arrowDown`} className={styles.svgIconUp} />
                            : <Svg id={`arrowDown`} className={styles.svgIconDown} />
                        }
                    </div>
                )}
            </div>
        </div>
    );
}
